import styled from 'styled-components';

import { SpaceBetweenBlock, VerticalCenterBlock } from '../../../styled';

export const CardWrapper = styled(SpaceBetweenBlock)<{ isActive: boolean }>`
  padding: 18px 24px;
  position: relative;
  border: 2px solid #c5d0db;
  border-radius: 4px;
  height: 128px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  ${(props) =>
    props.isActive &&
    `
        background-color: rgba(0, 199, 126, 0.04);
        border: 2px solid ${props.theme.colors.action};
      `}
  :hover {
    background-color: rgba(0, 199, 126, 0.04);
    border: 2px solid ${(props) => props.theme.colors.action};
  }
`;

export const TextWrapper = styled(VerticalCenterBlock)`
  flex-direction: column;
  align-items: start;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
`;

export const CardSubtitle = styled.p`
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.colors.muted};
  a {
    text-decoration: none;
  }
`;

export const ExampleImage = styled.div`
  max-width: 195px;
  padding-right: 15px;
`;

export const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  background-color: ${(props) => props.theme.colors.text};
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-right-radius: 4px;
`;
